var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page"},[_c('div',{staticClass:"playerDiv"},[_c('PlayerTableAdt',{attrs:{"season":_vm.season,"config":_vm.config,"DEFIMAGESAMS3":_vm.DEFIMAGESAMS3,"develop":_vm.develop}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }